import { render, staticRenderFns } from "./Ocr.vue?vue&type=template&id=e3096418&scoped=true&"
import script from "./Ocr.vue?vue&type=script&lang=js&"
export * from "./Ocr.vue?vue&type=script&lang=js&"
import style0 from "./Ocr.vue?vue&type=style&index=0&id=e3096418&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3096418",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCard,VContainer,VDialog,VDivider,VImg,VSheet})
